export default { "columns":68,
 "image":"VP2_Interiors.png",
 "imageheight":800,
 "imagewidth":1088,
 "margin":0,
 "name":"vp2Interriors",
 "spacing":0,
 "tilecount":3400,
 "tiledversion":"1.11.0",
 "tileheight":16,
 "tiles":[
        {
         "id":952,
         "type":"ground"
        }, 
        {
         "id":953,
         "type":"ground"
        }, 
        {
         "id":954,
         "type":"ground"
        }, 
        {
         "id":955,
         "type":"ground"
        }, 
        {
         "id":956,
         "type":"ground"
        }, 
        {
         "id":957,
         "type":"ground"
        }, 
        {
         "id":958,
         "type":"ground"
        }, 
        {
         "id":959,
         "type":"ground"
        }, 
        {
         "id":960,
         "type":"ground"
        }, 
        {
         "id":961,
         "type":"ground"
        }, 
        {
         "id":962,
         "type":"ground"
        }, 
        {
         "id":963,
         "type":"ground"
        }, 
        {
         "id":964,
         "type":"ground"
        }, 
        {
         "id":965,
         "type":"ground"
        }, 
        {
         "id":966,
         "type":"ground"
        }, 
        {
         "id":967,
         "type":"ground"
        }, 
        {
         "id":2040,
         "type":"ground"
        }, 
        {
         "id":2041,
         "type":"ground"
        }, 
        {
         "id":2042,
         "type":"ground"
        }, 
        {
         "id":2043,
         "type":"ground"
        }, 
        {
         "id":2044,
         "type":"ground"
        }, 
        {
         "id":2045,
         "type":"ground"
        }, 
        {
         "id":2046,
         "type":"ground"
        }, 
        {
         "id":2047,
         "type":"ground"
        }, 
        {
         "id":2048,
         "type":"ground"
        }, 
        {
         "id":2049,
         "type":"ground"
        }, 
        {
         "id":2050,
         "type":"ground"
        }, 
        {
         "id":2051,
         "type":"ground"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};